import { Box } from "@mui/material"
import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { ProductInventoryDetailsPage } from "@/screens/Inventory/subfeatures/ProductInventory/components"
import { productInventoryDetailsSearchSchema } from "@/screens/Inventory/subfeatures/ProductInventory/schemas"

export const Route = createFileRoute("/app/inventory/products/$productId/_layout")({
  validateSearch: zodValidator(productInventoryDetailsSearchSchema),
  component: () => (
    <Box className='flex size-full flex-col'>
      <PermissionContentWrapper permissions={[PermissionActionType.INVENTORY_VIEW]}>
        <ProductInventoryDetailsPage />
      </PermissionContentWrapper>
    </Box>
  ),
})
